import { DISCOUNT_TYPE, COUPONS, MAXIC_DISCOUNT_PROD_TYPE, SEND_CURRENT_OFFERS_URL } from '../../config';
import _ from 'lodash';
import axios from 'axios';
import {
	DISCOUNT_APPLY_MAGIX,
	DISCOUNT_APPLY_COUPON_SET_ID,
	DISCOUNT_CLEAR_APPLIED,
	COUPON_FETCH,
	COUPON_FETCH_SUCCESS,
	COUPON_FETCH_FAIL,
	COUPON_APPLY_WITHOUT_VALIDATION,
	SET_USER_SUPPLIED_PROMO_CODE,
	SUBSCRIPTION_GET_ESTIMATE,
	SUBSCRIPTION_GET_ESTIMATE_SUCCESS,
	SUBSCRIPTION_GET_ESTIMATE_FAIL,
	COUPON_CHANGE_TYPE,
	COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE
} from './actions';

import { extractPropsforSuperagentHttpError, extractPropsforAxiosHttpError } from '../../errors/errorhelper';
import ERRORS from '../../errors/errorids';
import AppError from '../../errors/apperror';
import HttpError from '../../errors/httperror';

import {
	SERIAL_NUMBER_PREFIXES_OLD_PRODUCTS,
	SERIAL_NUMBER_PREFIXES_NEW_PRODUCTS,
	DISCOUNTS_CONFIG,
	DISCOUNT_KEY
} from '../../config';

import Logger from '../../logger/logger';
const log = Logger.get('discount');

const initialState = {
	isDiscountApplied: false,
	discountType: null,
	couponSetKey: null,
	couponId: null,
	failedCouponId: null,
	couponType: null,
	/* magix discount props */
	usedMagixEmail: null,
	usedProductSerial: null,
	appliedProdCatOfLastValidCombination: null,
	appliedProdTypeOfLastValidCombination: null,
	appliedTierOfLastValidCombination: null,
	couponCodeFetchSuccess: null,
	couponCodeFetchErrorId: null,
	couponCodeInvalidReason: null,
	couponConfig: null,
	pendingRequest: null,
	userSuppliedPromoCode: null,
	couponAppliedWithoutValidation: null,
	isResponsePendingFromEstimationEndpoint: null
};

const getCouponConfig = (response) => {
	let result = null;

	const planKeys = Object.keys(response);
	for (const planKey of planKeys) {
		const config = _.get(response[planKey], 'estimation.retrievedClientCouponIds[0].couponDetails');
		const error = _.get(response[planKey], 'estimation.couponRelatedError');

		// must be used to detect used one time coupons
		const showDiscountForPlan = Boolean(_.get(response[planKey], 'estimation.totalDiscountAmountWithoutTax'));

		if (config && !error && showDiscountForPlan) {
			result = config;
			break;
		}
	}

	if (!result) {
		const firstPlan = response[planKeys[0]];
		const config = _.get(firstPlan, 'estimation.retrievedClientCouponIds[0].couponDetails');
		const addonList = _.get(firstPlan, 'estimation.retrievedClientCouponIds[0].couponDetails.addon_ids');

		const isCouponActive = _.get(firstPlan, 'estimation.retrievedClientCouponIds[0].couponDetails.status') === 'active';

		if (isCouponActive && !_.isEmpty(addonList)) {
			const perpetualAddonFound = addonList.some(addon => addon.indexOf('webl') !== -1 ||
							addon.indexOf('designerl') !== -1 ||
							addon.indexOf('photol') !== -1);

			perpetualAddonFound && (result = config);
		}
	}

	return result;
};

const getErrorReason = (response) => {
	const planKeys = Object.keys(response);
	const firstPlan = response[planKeys[0]];
	const retrieved_coupons = _.get(firstPlan, 'estimation.retrievedClientCouponIds');
	const coupon_status = _.get(firstPlan, 'estimation.retrievedClientCouponIds[0].couponDetails.status');
	const coupon_duration = _.get(firstPlan, 'estimation.retrievedClientCouponIds[0].couponDetails.duration_type');
	const error = _.get(firstPlan, 'estimation.couponRelatedError');
	const showDiscountForPlan = Boolean(_.get(firstPlan, 'estimation.totalDiscountAmountWithoutTax'));
	const hasOldCoupon = !_.isEmpty(_.get(firstPlan, 'estimation.appliedCouponIds[0].couponDetails'));

	if (error === 'coupon_not_applicable') {
		return 'not-applicable-to-any-of-products';
	} else if (coupon_status === 'expired') {
		return coupon_status;
	} else if (_.isEmpty(retrieved_coupons)) {
		return 'does-not-exist';
	} else if (!showDiscountForPlan && coupon_status === 'active' && hasOldCoupon) {
		// case when company used forever coupon in the past
		return 'cannot-replace-existing-coupon';
	} else if (!showDiscountForPlan && coupon_duration === 'one_time') {
		// case when company used one-time coupon in the past
		// in this case MW does not return estimation.appliedCouponIds[0] so hasOldCoupon check cannot be used
		return 'one-time-coupon-used';
	}
};

export default (state = initialState, action) => {
	let isCouponActive;

	switch (action.type) {

		case DISCOUNT_APPLY_MAGIX: {
			// User can check another serial/email for another product and get lower discount,
			// so apply it only when clicking on Apply discount button
			// user can still close discount popup without applying discount
			let tierKey;
			if (action.payload.prodTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.SUBSCRIPTION) {
				tierKey = action.payload.tierOfLastValidCombination;
			} else if (action.payload.prodTypeOfLastValidCombination === MAXIC_DISCOUNT_PROD_TYPE.PERPETUAL) {
				tierKey = action.payload.prodCatOfLastValidCombination;
			}

			const couponSetKey = `tier_${tierKey}`;

			return {
				...state,
				isDiscountApplied: true,
				discountType: DISCOUNT_TYPE.MAGIX,
				couponSetKey,
				couponId: null,
				failedCouponId: null,
				couponType: null,
				appliedProdCatOfLastValidCombination: action.payload.prodCatOfLastValidCombination,
				appliedProdTypeOfLastValidCombination: action.payload.prodTypeOfLastValidCombination,
				appliedTierOfLastValidCombination: action.payload.tierOfLastValidCombination,
				usedMagixEmail: action.payload.magixEmail,
				usedProductSerial: action.payload.productSerial,
				couponCodeFetchSuccess: null,
				couponCodeFetchErrorId: null,
				couponCodeInvalidReason: null,
				couponConfig: null,
				pendingRequest: null,
				userSuppliedPromoCode: null,
				couponAppliedWithoutValidation: null,
				isResponsePendingFromEstimationEndpoint: null
			};
		}

		case COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE: {
			if (state.appliedProdTypeOfLastValidCombination &&
					state.appliedProdTypeOfLastValidCombination !== action.payload.magixDiscountProdType) {

				const tierKey = action.payload.tierOfLastValidCombination || action.payload.prodCatOfLastValidCombination;
				const couponSetKey = `tier_${tierKey}`;

				return {
					...state,
					isDiscountApplied: action.payload.areCredentialsValid,
					couponSetKey,
					appliedProdTypeOfLastValidCombination: action.payload.magixDiscountProdType
				};

			} else {
				return state;
			}
		}

		case DISCOUNT_APPLY_COUPON_SET_ID: {
			return {
				...state,
				isDiscountApplied: true,
				discountType: DISCOUNT_TYPE.COUPON_SET_ID,
				couponSetKey: action.payload.setId,
				couponId: null,
				failedCouponId: null,
				couponType: null,
				appliedProdCatOfLastValidCombination: null,
				appliedProdTypeOfLastValidCombination: null,
				appliedTierOfLastValidCombination: null,
				usedMagixEmail: null,
				usedProductSerial: null,
				couponCodeFetchSuccess: null,
				couponCodeFetchErrorId: null,
				couponCodeInvalidReason: null,
				couponConfig: null,
				pendingRequest: null,
				userSuppliedPromoCode: null,
				couponAppliedWithoutValidation: null,
				isResponsePendingFromEstimationEndpoint: null
			};
		}

		case SET_USER_SUPPLIED_PROMO_CODE:
			return {
				...state,
				userSuppliedPromoCode: action.payload.value
			};			

		case COUPON_APPLY_WITHOUT_VALIDATION: {
			return {
				...state,
				couponAppliedWithoutValidation: true,
				isResponsePendingFromEstimationEndpoint: true,

				couponCodeFetchSuccess: null,
				couponCodeFetchErrorId: null,
				couponCodeInvalidReason: null,				
				
				couponConfig: null,
				
				discountType: action.payload.discountType,
				couponType: action.payload.couponType,
				isDiscountApplied: null,
				couponSetKey: null,
				usedMagixEmail: null,
				usedProductSerial: null
			};			
		}
			
		case SUBSCRIPTION_GET_ESTIMATE: {
			return action.payload.couponId || action.payload.couponSetId
				?
				{
					...state,
					couponCodeFetchSuccess: null,
					couponCodeFetchErrorId: null,
					couponCodeInvalidReason: null,
					couponConfig: null,
					pendingRequest: true,
				}
				:
				{
					...state
				};			
		}

		case COUPON_FETCH:
			return {
				...state,
				couponCodeFetchSuccess: null,
				couponCodeFetchErrorId: null,
				couponCodeInvalidReason: null,
				couponConfig: null,
				pendingRequest: true,
				failedCouponId: null,
				couponAppliedWithoutValidation: null,
				isResponsePendingFromEstimationEndpoint: null
			};			


		case SUBSCRIPTION_GET_ESTIMATE_SUCCESS: {
			const couponConfig = getCouponConfig(action.result);

			if (action.payload.couponId) {
				return {
					...state,
					isDiscountApplied: !_.isEmpty(couponConfig),
					discountType: action.payload.discountType,
					couponSetKey: null,
					couponId: action.payload.couponId,
					failedCouponId: null,
					couponType: action.payload.couponType,
					appliedProdCatOfLastValidCombination: null,
					appliedProdTypeOfLastValidCombination: null,
					appliedTierOfLastValidCombination: null,
					usedMagixEmail: null,
					usedProductSerial: null,					
					couponCodeFetchSuccess: !_.isEmpty(couponConfig),
					couponCodeFetchErrorId: null,
					couponCodeInvalidReason: _.isEmpty(couponConfig) ? getErrorReason(action.result) : null,
					couponConfig: couponConfig,
					pendingRequest: false,
					isResponsePendingFromEstimationEndpoint: false,
					// Keep true to allow reading coupon input value 
					// in Subscription.getCouponDataForSubscriptionEstimate when user changes seats quantity
					couponAppliedWithoutValidation: true
				};
			} else if (action.payload.couponSetId) {
				
				return {
					...state,
					isDiscountApplied: !_.isEmpty(couponConfig),
					discountType: action.payload.discountType,
					couponSetKey: action.payload.couponSetKey,
					couponId: null,
					failedCouponId: null,
					couponType: action.payload.couponType,
					appliedTierOfLastValidCombination: null,
					...(action.payload.couponSetId !== DISCOUNTS_CONFIG[DISCOUNT_KEY.TIER1].coupon_set_id &&
						action.payload.couponSetId !== DISCOUNTS_CONFIG[DISCOUNT_KEY.TIER2].coupon_set_id &&
						action.payload.couponSetId !== DISCOUNTS_CONFIG[DISCOUNT_KEY.TIER3].coupon_set_id &&
						action.payload.couponSetId !== DISCOUNTS_CONFIG[DISCOUNT_KEY.PHOTOL].coupon_set_id &&
						action.payload.couponSetId !== DISCOUNTS_CONFIG[DISCOUNT_KEY.WEBL].coupon_set_id &&
						action.payload.couponSetId !== DISCOUNTS_CONFIG[DISCOUNT_KEY.DESIGNERL].coupon_set_id &&
						{	usedMagixEmail: null,
							usedProductSerial: null,
							appliedProdCatOfLastValidCombination: null,
							appliedProdTypeOfLastValidCombination: null
						}),
					couponCodeFetchSuccess: !_.isEmpty(couponConfig),
					couponCodeFetchErrorId: null,
					couponCodeInvalidReason: _.isEmpty(couponConfig) ? getErrorReason(action.result) : null,
					couponConfig: couponConfig,
					pendingRequest: false,
					isResponsePendingFromEstimationEndpoint: false,
					// Keep true to allow reading coupon input value 
					// in Subscription.getCouponDataForSubscriptionEstimate when user changes seats quantity
					couponAppliedWithoutValidation: true
				};
			} else {
				return {
					...state,
					isResponsePendingFromEstimationEndpoint: false,
					couponAppliedWithoutValidation: false
				};
			}
		}			

		case COUPON_FETCH_SUCCESS:
			isCouponActive = _.get(action, 'result.coupon.status') === 'active';
			return {
				...state,
				isDiscountApplied: isCouponActive,
				discountType: DISCOUNT_TYPE.COUPON_ID,
				couponSetKey: null,
				couponId: action.payload.couponId,
				failedCouponId: null,
				couponType: action.payload.couponType,
				appliedProdCatOfLastValidCombination: null,
				appliedProdTypeOfLastValidCombination: null,
				appliedTierOfLastValidCombination: null,
				usedMagixEmail: null,
				usedProductSerial: null,
				couponCodeFetchSuccess: isCouponActive,
				couponCodeFetchErrorId: null,
				couponCodeInvalidReason: !isCouponActive ? 'expired' : null,
				couponConfig: action.result.coupon,
				pendingRequest: false
			};

		case SUBSCRIPTION_GET_ESTIMATE_FAIL: {
			return action.payload.couponId || action.payload.couponSetId
				?
				{
					...state,
					isDiscountApplied: false,
					discountType: null,
					couponCodeFetchSuccess: false,
					couponCodeFetchErrorId: _.get(action, 'error.errorId'),
					couponCodeInvalidReason: _.get(action, 'error.reason'),
					couponConfig: null,
					pendingRequest: true,
					//allow resubmit on offline error - check is done in Subscription.componentDidUpdate
					couponAppliedWithoutValidation: false,
					isResponsePendingFromEstimationEndpoint: false
				}
				:
				{
					...state,
				};	
		}

		case COUPON_FETCH_FAIL: {
			return {
				...state,
				failedCouponId: _.get(action.payload, 'couponId'),
				isDiscountApplied: false,
				couponCodeFetchSuccess: false,
				couponCodeFetchErrorId: _.get(action, 'error.errorId'),
				couponCodeInvalidReason: _.get(action, 'error.reason'),
				couponConfig: null,
				pendingRequest: false
			};
		}

		case DISCOUNT_CLEAR_APPLIED: {
			return {
				...initialState,
				pendingRequest: false
			};
		}

		case COUPON_CHANGE_TYPE:
			return {
				...state,
				couponType: action.payload.couponType
			};			

		default:
			return state;

	}
};

export const applyMagixDiscount = (
	magixEmail,
	productSerial,
	prodCatOfLastValidCombination,
	tierOfLastValidCombination,
	prodTypeOfLastValidCombination) => {
	return dispatch => {
		dispatch({
			type: DISCOUNT_APPLY_MAGIX,
			payload: {
				magixEmail,
				productSerial,
				prodCatOfLastValidCombination,
				tierOfLastValidCombination,
				prodTypeOfLastValidCombination
			}
		});
	};
};

export const applyDiscountUsingCouponSetId = (setId) => {
	return dispatch => {
		dispatch({
			type: DISCOUNT_APPLY_COUPON_SET_ID,
			payload: { setId }
		});
	};
};

export const clearAppliedDiscount = () => {
	return dispatch => {
		dispatch({
			type: DISCOUNT_CLEAR_APPLIED
		});
	};
};

/**
 * Validate coupon id and apply it
 *
 * @param {string} coupon_id coupon id
 * @returns dispatch
 */
export const applyDiscountUsingCouponId = (couponId, couponType, isAutoApplied) => {
	return (dispatch, getState) => {
		const { companies } = getState();
		const url = `${COUPONS.GET_COUPON_INFO}?id=${companies.selectedId}&couponId=${encodeURIComponent(couponId)}`;

		if ([...SERIAL_NUMBER_PREFIXES_OLD_PRODUCTS, 
			...SERIAL_NUMBER_PREFIXES_NEW_PRODUCTS].includes(couponId.split('-')[0].toUpperCase())) {
			dispatch({
				type: COUPON_FETCH_FAIL,
				error: { 
					errorId: ERRORS.COUPON_CODE_DOES_NOT_EXIST,
					reason: 'serial-number'
				}
			});
		} else {
			return dispatch({
				types: [COUPON_FETCH, COUPON_FETCH_SUCCESS, COUPON_FETCH_FAIL],
				payload: { couponId, couponType, isAutoApplied },
				promise: client => client.get(url)
					.catch((error) => {
						const httpErrorProps = extractPropsforSuperagentHttpError(error);
						const nError = new AppError({
							message: 'discount.getCouponInfo() failed',
							errorId: ERRORS.UNKNOWN,
							originalError: new HttpError(httpErrorProps),
							visualisers: { feature: 'REDUX_COUPON' }
						});
	
						throw nError;
					})
			});
		}
	};
};

export const applyDiscountUsingCouponIdWithoutValidation = 
	(couponId, couponType, isAutoApplied, discountType) => {
		return (dispatch) => {
			if ([...SERIAL_NUMBER_PREFIXES_OLD_PRODUCTS, 
				...SERIAL_NUMBER_PREFIXES_NEW_PRODUCTS].includes(couponId.split('-')[0].toUpperCase())) {
				dispatch({
					type: COUPON_FETCH_FAIL,
					error: { 
						errorId: ERRORS.COUPON_CODE_DOES_NOT_EXIST,
						reason: 'serial-number'
					}
				});
			} else {
				dispatch({
					type: COUPON_APPLY_WITHOUT_VALIDATION,
					payload: { couponId, couponType, isAutoApplied, discountType}
				});
			}
		};
	};

export const setUserSuppliedPromoCode = (value) => {
	return dispatch => {
		dispatch({
			type: SET_USER_SUPPLIED_PROMO_CODE,
			payload: { value }
		});
	};
};

export const changeCouponType = (couponType) => {
	return dispatch => {
		dispatch({
			type: COUPON_CHANGE_TYPE,
			payload: { couponType }
		});
	};
};

const activeCouponSendToUserForType = [];

export const sendCurrentOfferToUser = (payload) => {

	if (activeCouponSendToUserForType.includes(payload.type)) return;
	activeCouponSendToUserForType.push(payload.type);

	axios.post(SEND_CURRENT_OFFERS_URL, payload)
		.catch(function (error) {
			const httpErrorProps = extractPropsforAxiosHttpError(error);
			log.send(new AppError({
				message: 'discount.sendCurrentOfferToUser() failed',
				errorId: ERRORS.UNKNOWN,
				originalError: new HttpError(httpErrorProps),
				errorDetails: payload,					
				visualisers: { feature: 'REDUX_COUPON' }
			}));
		});
};


// WEBPACK FOOTER //
// ./src/redux/modules/discount.js